
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3GY0W", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f6edb46ad8d543e1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $f6edb46ad8d543e1$export$2e2bcd8739ae039 = {
    'confluence.error.panel.refresh.app': 'Uppdatera appen',
    'confluence.error.panel.reload.page': 'Uppdatera sida',
    'confluence.icon.label': 'Ikon',
    'confluence.modal.dialog.close.modal.button': 'Avbryt',
    'confluence.select.required.field.message': "F\xe4ltet \xe4r obligatoriskt.",
    'confluence.text.area.required.field.message': "F\xe4ltet \xe4r obligatoriskt.",
    'confluence.textfield.validator.email': 'Ange en giltig e-postadress.',
    'confluence.textfield.validator.number': 'Ange ett giltigt nummer',
    'confluence.textfield.validator.required.field.message': "F\xe4ltet \xe4r obligatoriskt.",
    'confluence.textfield.validator.telephone': 'Ange ett giltigt telefonnummer.',
    'confluence.threeLOPrompt.modal.access.required.title': "\xc5tkomst kr\xe4vs",
    'confluence.threeLOPrompt.modal.error.title': 'Fel',
    'confluence.threeLOPrompt.modal.no.authURL.error-message': "URL f\xf6r samtycke hittades inte. Uppdatera sidan och f\xf6rs\xf6k igen.",
    'confluence.threeLOPrompt.no.authURL.error-message': "URL f\xf6r samtycke hittades inte. Uppdatera sidan och f\xf6rs\xf6k igen.",
    'confluence.threeLOPrompt.use-auth.allow.access.button.text': "Till\xe5t \xe5tkomst",
    'confluence.threeLOPrompt.use-auth.configure.access.button.text': "Konfigurera \xe5tkomst",
    'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': 'Det gick inte att autentisera.',
    'confluence.threeLOPrompt.use-auth.default.prompt.message': "F\xf6r att {appString} ska visas m\xe5ste du ge appen \xe5tkomst till Atlassian-produkter f\xf6r din r\xe4kning.",
    'confluence.threeLOPrompt.use-auth.external.auth.prompt.message': "{appString} kr\xe4ver ytterligare \xe5tkomst till ditt konto.",
    'confluence.threeLOPrompt.use-auth.external.auth.warning.message': 'Extern aut.varning',
    'confluence.threeLOPrompt.use-auth.this.app.lower.message': "den h\xe4r appen",
    'confluence.threeLOPrompt.use-auth.this.app.upper.message': "Den h\xe4r appen",
    'confluence.user.group.unknown.user.message': "Ok\xe4nd anv\xe4ndare",
    'confluence.user.picker.empty.field.error.message': "F\xe4ltet \xe4r obligatoriskt.",
    'confluence.user.unknown.user.message': "Ok\xe4nd anv\xe4ndare",
    'forge-ui.form.submit-button.text': 'Skicka in'
};

});


//# sourceMappingURL=sv.c8698f75.js.map
